module.exports = __webpack_public_path__ + "static/img/1808_5.fcdfc8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_5.jpg
// module id = meYN
// module chunks = 1